import { CascadeSelect, type } from './CascadeSelect';

/**
 * Extensión que reemplaza el renderizado del tipo 'select' estándar
 * para añadir soporte de filtrado en cascada en tiempo de ejecución.
 *
 * Sólo debe añadirse al visor (createForm), NO al editor (FormEditor),
 * ya que la cascada es un comportamiento de tiempo de ejecución.
 */
class CascadeFormFields {
  constructor(formFields) {
    formFields.register(type, CascadeSelect);
  }
}

export default {
  __init__: ['cascadeSelect'],
  cascadeSelect: ['type', CascadeFormFields],
};
